import $ from 'jquery';

$(document).ready(() => {
	$('.teams__list a').bind('click', (event) => {
		event.preventDefault();
		const $btn = $(event.currentTarget);
		const $parent = $btn.closest('.teams');
		const $target = $($btn.attr('href'));
		$parent.find('.teams__list li.active').removeClass('active');
		$btn.parent().addClass('active');
		$parent.find('.teams__item.active').removeClass('active');
		$target.addClass('active');
	});
	$('.teams__age-groups a').bind('click', (event) => {
		event.preventDefault();
		const $btn = $(event.currentTarget);
		const $parent = $btn.closest('.teams');
		const $dropdown = $btn.closest('.teams__age-groups');
		const $target = $($btn.attr('href'));
		$parent.find('.teams__item.active').removeClass('active');
		$dropdown.find('.teams__selected-group').text($btn.text());
		$parent.find('.teams__list--active').removeClass('teams__list--active');
		$parent.find('.teams__list .active').removeClass('active');
		$target.addClass('teams__list--active');
		$target.find('li:first-child').addClass('active');
		$($target.find('li:first-child a').attr('href')).addClass('active');
		$dropdown.removeClass('open');
	});
	$('.teams__age-groups button').bind('click', (event) => {
		const $parent = $(event.currentTarget).closest('.teams__age-groups');
		$parent.toggleClass('open');
	});
});

document.fonts.load('1rem "titling-gothic-fb-wide"').then(() => {
	$('.teams__age-groups').each(function(){
		const $list = $(this).find('ul');
		$list.css({display: 'block'});
		const bounds = $list[0].getBoundingClientRect();
		$list.css({display: ''});
		$list.parent().css({width: bounds.width});
	});
});
